<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import NotRunningCampaignState from "./NotRunningCampaignState.svelte";
</script>

<NotRunningCampaignState title={$copy.over.title} subtitle={$copy.over.subtitle} />